import { render, staticRenderFns } from "./LiveStats.vue?vue&type=template&id=7332a7bd&"
import script from "./LiveStats.vue?vue&type=script&lang=js&"
export * from "./LiveStats.vue?vue&type=script&lang=js&"
import style0 from "./LiveStats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports